import React, { useEffect, useState } from 'react'
import { Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'

// Toast سراسری — جایگزین alert()های مرورگر در کل سامانه
let listener = null

export const toast = (text, severity = 'error') => {
  if (listener) listener({ key: Date.now(), text, severity })
}

export const GlobalToast = () => {
  const [item, setItem] = useState(null)

  useEffect(() => {
    listener = setItem
    return () => { listener = null }
  }, [])

  return (
    <Snackbar
      open={!!item}
      autoHideDuration={5000}
      onClose={() => setItem(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      {item ? (
        <MuiAlert elevation={6} variant="filled" severity={item.severity} onClose={() => setItem(null)}>
          {item.text}
        </MuiAlert>
      ) : undefined}
    </Snackbar>
  )
}
